import React, { FC } from "react";
import { Theme, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Field, FormRenderProps } from "react-final-form";
import BootstrapInput from "../../../components/BootstrapInput";
import Button from "../../../components/Button";
import Loading from "../../../components/Loading";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    "& + &": {
      marginTop: theme.spacing(2),
    },
  },
  processingFee: {
    marginBottom: theme.spacing(1),
    fontWeight: "bold",
    fontStyle: "italic",
  },
  title: {
    fontWeight: "bold",
    fontSize: 22,
  },
}));

const MakeServicePaymentForm: FC<FormRenderProps> = ({
  submitting,
  handleSubmit,
  values,
}) => {
  const classes = useStyles();
  const amountWithFee = (
    values?.amount ? +values.amount + +values.amount / 10 : 0
  ).toFixed(2);

  return (
    <form noValidate onSubmit={handleSubmit}>
      {submitting && <Loading />}
      <Typography align="center" component="h1" className={classes.title}>
        Make a service payment
      </Typography>
      <Typography component="div" className={classes.formControl}>
        <Field
          required
          fullWidth
          type="text"
          label="Amount (USD)"
          placeholder="Amount (USD)"
          name={"amount"}
          component={BootstrapInput}
        />
      </Typography>
      <Typography component="p" className={classes.processingFee}>
        Note: 10% processing fee will be added to your payment
      </Typography>
      <Typography component="div" className={classes.formControl}>
        <Field
          required
          fullWidth
          type="text"
          label="Comment"
          placeholder="Comment"
          multiline={true}
          rows={5}
          name={"comment"}
          component={BootstrapInput}
        />
      </Typography>
      <Typography
        align="center"
        component="div"
        className={classes.formControl}
      >
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={submitting}
        >
          Checkout ({amountWithFee} USD)
        </Button>
      </Typography>
    </form>
  );
};

export default MakeServicePaymentForm;
